/** Specific vocabulary to be used to give repeatable content a distinct brand voice
 * @example
 * import { DefaultVocab } from '@sainsburys-tech/vocab'
 *
 * return (
 *   <Button>{ DefaultVocab.ADD_TO_TROLLEY }</Button>
 * )
 * @example
 * const Button = () => {
 * const { ADD_TO_TROLLEY } = useVocab()
 * return (
 *   <Button>{ ADD_TO_TROLLEY }</Button>
 * )
 */
const DefaultVocab = {
  BRAND_NAME: 'Global',
  ADD_TO_TROLLEY: 'Add to trolley',
  ITEM_CONTAINER: 'trolley'
}

export default DefaultVocab
